import { reactive, ref } from 'vue'

let state = reactive({
  image1: null,
  image1Caption: null,
  image2: null,
  image2Caption: null,
  embedImage: false,
  embedVideo: false,
  video: null,
  videoCaption: null,
})

const showWarningMessage = ref(false)

const setState = ({ pressReleaseContentAttachments = {} }) => {
  const { image1, image1Url, image2Url, image2 } =
    pressReleaseContentAttachments

  const payload = {
    ...pressReleaseContentAttachments,
    image1: image1 ? { fileContent: image1Url } : null,
    image2: image2 ? { fileContent: image2Url } : null,
  }
  state = reactive({
    ...state,
    ...payload,
  })
}

const clearState = () => {
  for (let key in state) {
    state[key] = null
  }
}

export { state, showWarningMessage, setState, clearState }
